(function () {
  "use strict";
  var doc = document;
  function busy(el, on) {
    if (!el) return;
    if (on) el.setAttribute("aria-busy", "true");
    else el.removeAttribute("aria-busy");
  }
  var CONTROL =
    ".xg-pressable, button, summary, [role='button'], a[class], label[class]:has(input)";
  var SLOP = 10;
  var held = null;
  var from = null;
  function offable(el) {
    return (
      el.hasAttribute("disabled") ||
      el.getAttribute("aria-disabled") === "true" ||
      el.getAttribute("aria-busy") === "true" ||
      el.getAttribute("data-xg-press") === "off"
    );
  }
  function release() {
    if (!held) return;
    held.removeAttribute("data-xg-press");
    held = null;
    from = null;
  }
  doc.addEventListener(
    "pointerdown",
    function (event) {
      if (event.pointerType === "mouse") return;
      release();
      var el = event.target.closest && event.target.closest(CONTROL);
      if (!el || offable(el)) return;
      held = el;
      from = { x: event.clientX, y: event.clientY };
      el.setAttribute("data-xg-press", "on");
    },
    { passive: true }
  );
  doc.addEventListener(
    "pointermove",
    function (event) {
      if (!held || !from) return;
      if (
        Math.abs(event.clientX - from.x) > SLOP ||
        Math.abs(event.clientY - from.y) > SLOP
      ) {
        release();
      }
    },
    { passive: true }
  );
  doc.addEventListener("pointerup", release, { passive: true });
  doc.addEventListener("pointercancel", release, { passive: true });
  doc.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || form.nodeType !== 1) return;
    var submitter =
      event.submitter || form.querySelector('button[type="submit"], [type="submit"]');
    if (!submitter) return;
    setTimeout(function () {
      if (event.defaultPrevented) return;
      busy(submitter, true);
    }, 0);
  });
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    var stuck = doc.querySelectorAll('[aria-busy="true"]');
    for (var i = 0; i < stuck.length; i += 1) busy(stuck[i], false);
  });
  window.XG = window.XG || {};
  window.XG.press = { busy: busy };
})();
